import React, { useState, useEffect } from 'react';
import Lottie from 'lottie-react';
import { useTranslation } from 'react-i18next';
import splashAnimation from '../assets/animations/s.json';

function SplashScreen({ onComplete = () => { } }) {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      onComplete();
    }, 2500);
    return () => clearTimeout(timer);
  }, [onComplete]);

  if (!isVisible) return null;

  return (
    <div className="splash-container">
      <div className="splash-content">
        {/* Lottie Animation */}
        <div className="splash-lottie-wrapper">
          <Lottie
            animationData={splashAnimation}
            loop={true}
            style={{ width: 300, height: 300 }}
          />
        </div>

        {/* Title */}
        <h1 className="splash-title">{t('appBar.permitManagementSystem')}</h1>

        {/* Subtitle */}
        <p className="splash-subtitle">{t('appBar.splashSubtitle')}</p>

        {/* Loader dots */}
        <div className="splash-loader">
          <span className="dot"></span>
          <span className="dot"></span>
          <span className="dot"></span>
        </div>

        {/* Version */}
        <span className="splash-version">v1.0.0</span>
      </div>
    </div>
  );
}

export default SplashScreen;
